import React from "react";

// Groupe titré de filtres : les champs s'enchaînent en ligne, chacun à la
// largeur de ce qu'il attend, et passent à la ligne quand la place manque.
const FilterGroup = ({ title, children }) => (
  <fieldset className="filter-group">
    <legend className="filter-group__title">{title}</legend>
    <div className="filter-group__fields">{children}</div>
  </fieldset>
);

export default FilterGroup;
